export interface WinnersTotal {
  totalEur: string;
  winnersCount: string;
}

export interface WinnerType {
  mul?: number;
  userId: string;
  screenName: string;
  currency: string;
  win: number;
  megawin: boolean;
  group?: string;
}
export interface CurrencyInfo {
  // TODO: maybe add currency code here as well?
  symbol: string;
  digitsNumber: number;
  groupNumber: number;
  decimalSeparator: string;
  groupSeparator: string;
}

export interface WinResultType {
  amount: number;
  isMegaWin: boolean;
  updateTimestamp: number;
}

// TODO: strictly define what is game status and what possible values should it have
export enum GameStatus {
  BetsAccepted = 'BetsAccepted',
  BetsClosed = 'BetsClosed',
  BetsRejected = 'BetsRejected',
  BonusRound = 'BonusRound',
  DealerWins = 'DealerWins',
  Dealing = 'Dealing',
  Drawing = 'Drawing',
  GameCancelled = 'GameCancelled',
  Green = 'Green',
  LastBets = 'LastBets', // TODO: I'm not actual when all games move to unified layout. Check and remove me
  MegaMultipliers = 'MegaMultipliers',
  Multipliers = 'Multipliers',
  NotAllBetsAccepted = 'NotAllBetsAccepted',
  PlaceYourBets = 'PlaceYourBets',
  Push = 'Push',
  Result = 'Result',
  Shuffling = 'Shuffling',
  SumTo = 'SumTo',
  Tumbling = 'Tumbling',
  WaitForNextGame = 'WaitForNextGame',
  WelcomeMsg = 'WelcomeMsg', // TODO: I'm not actual when all games move to unified layout. Check and remove me
  YouWin = 'YouWin',
}

export interface DealerType {
  name: string;
  id: string | null;
}

export interface TableType {
  openTime: number;
}

export interface TableCloseNotifyType {
  tableId: string;
  duration: string;
}
